import React, { FC } from "react";
import { CircularProgress, Flex } from "@evergis/ui";

export const ContainerLoading: FC = () => (
  <Flex center style={{ width: "100%" }}>
    <CircularProgress diameter={3} />
  </Flex>
);
